/** URL встроенной звонилки (WebRTC SFU). Переопределяется через VITE_CALL_APP_URL при сборке. */
export const CALL_APP_URL =
  (import.meta.env.VITE_CALL_APP_URL as string | undefined)?.trim() ||
  "https://sfu.bezpart-server.ru/";

/** Минимальная доля ширины/высоты панели звонилки (0–1). */
export const CALL_SPLIT_MIN_RATIO = 0.22;

/** Максимальная доля панели звонилки — почти на весь экран, доска остаётся полоской. */
export const CALL_SPLIT_MAX_RATIO = 0.95;

export const CALL_SPLIT_DEFAULT_RATIO = 0.38;

/** Доля высоты панели звонка на узких экранах (колонка). */
export const CALL_SPLIT_DEFAULT_MOBILE_RATIO = 0.48;

export const CALL_SPLIT_STORAGE_KEY = "bezpart-board-call-split";
export const CALL_SPLIT_MOBILE_STORAGE_KEY = "bezpart-board-call-split-mobile";

/** «Дизайн-размер» UI звонилки внутри iframe — масштабируется под окно. */
export const CALL_MINI_IFRAME_REF_WIDTH = 420;
/** Выше, чтобы влезали настройки и окно приглашения с QR-кодом. */
export const CALL_MINI_IFRAME_REF_HEIGHT = 480;

/** Позиция и размер плавающего окна звонка. */
export const CALL_MINI_WINDOW_STORAGE_KEY = "bezpart-board-call-mini-window";

export const CALL_MINI_WINDOW_DEFAULT_WIDTH = 360;
export const CALL_MINI_WINDOW_DEFAULT_HEIGHT = 280;

/** Минимальный масштаб UI звонилки в плавающем окне. */
export const CALL_MINI_IFRAME_MIN_SCALE = 0.34;

export const CALL_MINI_WINDOW_MIN_WIDTH = Math.ceil(
  CALL_MINI_IFRAME_REF_WIDTH * CALL_MINI_IFRAME_MIN_SCALE
);
export const CALL_MINI_WINDOW_MIN_CONTENT_HEIGHT = Math.ceil(
  CALL_MINI_IFRAME_REF_HEIGHT * CALL_MINI_IFRAME_MIN_SCALE
);
export const CALL_MINI_WINDOW_VIEWPORT_MARGIN = 12;

/** Оценка высоты шапки плавающего окна (px), если DOM ещё не измерен. */
export const CALL_MINI_WINDOW_HEADER_EST = 42;

export const CALL_MINI_WINDOW_MIN_HEIGHT =
  CALL_MINI_WINDOW_MIN_CONTENT_HEIGHT + CALL_MINI_WINDOW_HEADER_EST;

/** Подставить текущий хост звонилки в сохранённую ссылку комнаты. */
export function normalizeCallEmbedUrl(storedUrl: string): string {
  const trimmed = storedUrl.trim();
  if (!trimmed) return CALL_APP_URL.replace(/\/$/, "");
  try {
    const parsed = new URL(trimmed);
    const base = new URL(CALL_APP_URL);
    if (!parsed.pathname.includes("/room/")) return trimmed.replace(/\/$/, "");
    parsed.protocol = base.protocol;
    parsed.host = base.host;
    return parsed.toString().replace(/\/$/, "");
  } catch {
    return trimmed.replace(/\/$/, "");
  }
}
